import Flickity from "flickity";

const IconColumnsSlider = (slides) => {

    var slider = new Flickity(slides, {
        adaptiveHeight: false,
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        watchCSS: true,
        freeScroll: false,
        wrapAround: true,
    });

}

export default IconColumnsSlider;